import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  context.occurs = response.data.occurs;
  context.action_occurs = response.data.action_occurs;
  context.rentals = response.data.rentals;

  context.defaultNewAutoAction = {
    action_occur_id: context.action_occurs[0].id,
    trigger_time: "Immediate",
    channel_id: "null",
    rental_ids: [],
    action_type: "email",
    recipient: "",
    recipients: [],
    channel_ids: [],
    also_to_guest: false,
    also_to_assigned_member: false,
    message: {
      email: '',
      sms: ''
    }
  };
  context.newAutoAction = Object.assign({}, context.defaultNewAutoAction);
  context.setTriggerTimeDependingFromLang();
  if (context.channels && context.channels.length > 0) {
    context.occurs.map((occur) => {
      occur.autoactions.map((autoaction) => {
        let ids = autoaction.channel_ids;
        if (ids === null || ids.length == context.channels.length) {
          autoaction.allChannelsChecked = true;
        } else {
          autoaction.allChannelsChecked = false;
        }
      })
    });
  }
  context.loading = false;
};

// When the request fails
const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, query) => {
  return Vue.$http.get('/actions' + query)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/automation/get.js